import { getGlobalize } from '../translate';

export const currencyFormatter = (value: number): string =>
    getGlobalize().numberFormatter({ minimumFractionDigits: 2 })(value);
